<template>
  <v-container fluid>
    <v-row class="common-card-row">
      <v-col class="pa-0 pb-3 pr-md-3 pb-md-0" cols="12" md="3">
        <v-col class="common-card-col">
          <RadialChartVT
            title="Total Assets in the Fleet"
            :subtitle="devices.length"
            :chartData="chartData"
            @on-click="apply_graph_filter($event)"
          />
        </v-col>
      </v-col>
      <v-col class="pa-0 pb-3 pr-md-3 pb-md-0" cols="12" md="3">
        <v-col class="common-card-col">
          <RadialChartVT
            title="Friendly vs Non Friendly"
            :subtitle="filtered_devices_known.length"
            :chartData="chart_data_devices_known"
            @on-click="apply_graph_filter($event)"
          />
        </v-col>
      </v-col>
      <v-col class="pa-0 pb-3 pr-md-3 pb-md-0" cols="12" md="3">
        <v-col class="common-card-col">
          <RadialChartVT
            title="Value of Assets Outside POIs"
            :subtitle="devices.length * device_cost"
            prefix="€"
            :chartData="chart_data_monetary"
          />
        </v-col>
      </v-col>
      <v-col class="pa-0" cols="12" md="3">
        <v-col class="common-card-col">
          <RadialChartVT
            title="Fluid vs Static Assets"
            :subtitle="devices.length"
            :chartData="chart_data_device_status"
            @on-click="apply_graph_filter($event)"
          />
        </v-col>
      </v-col>
    </v-row>

    <v-row class="common-card-row pb-3">
      <v-col cols="12" md="6" class="pa-0 pr-md-3">
        <v-col cols="12" class="common-card-col">
          <v-card-title class="pl-0 text-h6 titleLight--text">{{ $t("common.words.devices") }} </v-card-title>
          <div class="d-flex mb-1" v-if="selected_poi && selected_poi.length > 0">
            <v-spacer></v-spacer>
            <v-btn outlined x-small class="mr-2" color="primary" @click="selected_poi = []"> Clear </v-btn>
          </div>
          <DataTableVT
            :headers="page_content.devices_table"
            :items_list="updated_filtered_devices"
            sort_by="LastMessageTime"
            item_key="DeviceID"
            :loading="is_loading"
          />
        </v-col>
      </v-col>
      <v-col cols="12" md="6" class="pa-0">
        <v-col v-if="map_data" cols="12" class="common-card-col">
          <MapsVT
            :options="page_content.maps_config"
            :items="map_data"
            :legends="$config.map_legends"
            :clusterMarkers="clusterMarkers"
            @marker_clicked="marker_clicked($event)"
            height="70vh"
          />
        </v-col>
      </v-col>
    </v-row>
    <v-snackbar color="borderDark" v-model="snackbar" timeout="2000">{{ message }}</v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import RadialChartVT from "../components/RadialChartVT";
import MapsVT from "../components/MapsVT";
import DataTableVT from "../components/DataTableVT";
import { axios_get } from "../services/vt_service";
import { tracking } from "../services/tracking";
import { content } from "../../config/fleet_report.json";

const tenant_key = process.env["VUE_APP_TENANT_KEY"];
const api_root = process.env["VUE_APP_ROOT_API"];

export default {
  name: "PoiReport",
  components: {
    RadialChartVT,
    MapsVT,
    DataTableVT,
  },
  data: function () {
    return {
      is_loading: true,
      snackbar: false,
      network_error: false,
      devices: [],
      search_term: "",
      error_message: "",
      device_cost: 0,
      total_assets: 0,
      total_assets_known: 0,
      total_assets_unknown: 0,
      perc_assets_known: 0,
      perc_assets_unknown: 0,
      value_missing_assets: 0,
      deviceId: null,
      dialog: false,
      selected_poi: [],
      message: "",
      clusterMarkers: true,
      chartOptions: {
        slices: {
          0: { color: "#DB4366" },
          1: { color: "#3B918B" },
        },
        pieHole: 0.4,
      },
      chartOptions2: {
        slices: {
          0: { color: "#f8961e" },
          1: { color: "#B0BEC5" },
        },
        pieHole: 0.4,
      },
      current_list: "all",
      location_data: null,
    };
  },
  created() {
    this.page_content = content;
  },
  mounted() {
    this.get_device_list();
    this.get_location_data();
    this.get_decvice_Settings();
    // this.$store.commit("update_page_title", "Fleet Report");
  },
  filters: {
    timeSince(date_string) {
      var date = new Date(date_string);
      var seconds = Math.floor((new Date() - date) / 1000);

      var interval = Math.floor(seconds / 31536000);

      if (interval > 1) {
        return interval + " years ago";
      }
      interval = Math.floor(seconds / 2592000);
      if (interval > 1) {
        return interval + " months ago";
      }
      interval = Math.floor(seconds / 86400);
      if (interval > 1) {
        return interval + " days ago";
      }
      interval = Math.floor(seconds / 3600);
      if (interval > 1) {
        return interval + " hours ago";
      }
      interval = Math.floor(seconds / 60);
      if (interval > 1) {
        return interval + " minutes ago";
      }
      return Math.floor(seconds) + " seconds ago";
    },
  },
  methods: {
    apply_graph_filter(val) {
      this.message = val ? "Filter Applied Successfully!" : "Filter Removed Successfully!";
      this.snackbar = true;
      let temp = val.split("(");
      this.current_list = temp[0];
    },
    open_details(deviceId) {
      this.deviceId = deviceId;
      this.dialog = true;
    },
    marker_clicked(obj) {
      this.selected_poi = obj[0] && obj[0].split(",");
    },
    async get_decvice_Settings() {
      this.network_error = false;
      const response = await axios_get(tracking.get_decvice_settings);
      let temp = response.filter((elem) => {
        if (elem["SettingName"] == "TrackedAssetValue") return true;
      });
      this.device_cost = temp[0]["SettingFloatValue"];
    },
    async get_device_list() {
      this.network_error = false;
      const response = await axios_get(tracking.get_device_list);
      this.devices = response;
      this.total_assets = this.devices.length;
      this.total_assets_known = this.devices.filter((dev) => {
        if (dev.LocationType) {
          return dev.LocationType.toLowerCase().includes("friendly");
        } else {
          return [];
        }
      }).length;
      this.total_assets_unknown = this.total_assets - this.total_assets_known;
      this.perc_assets_known = Math.round((parseFloat(this.total_assets_known) / this.total_assets) * 100);
      this.perc_assets_unknown = Math.round((parseFloat(this.total_assets_unknown) / this.total_assets) * 100);
      this.value_missing_assets = this.total_assets_unknown * 100;
      this.is_loading = false;
    },
    async get_location_data() {
      this.network_error = false;
      const accessToken = await this.$auth.getTokenSilently();
      this.network_error = false;
      var self = this;
      const tenant = this.$auth.user[tenant_key]["tenant"];
      let header = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Tenant: tenant,
        },
      };
      let locations_req = axios.get(api_root + "/api/location", header);
      let stats_req = axios.get(api_root + "/api/location/stats", header);
      axios
        .all([locations_req, stats_req])
        .then(
          axios.spread((...responses) => {
            let location_data = responses[0].data;
            let stats_data = responses[1].data;
            var hash = new Map();
            location_data.concat(stats_data).forEach(function (obj) {
              hash.set(obj.FullName, Object.assign(hash.get(obj.FullName) || {}, obj));
            });
            location_data = Array.from(hash.values());
            self.location_data = {};
            location_data.map((elem) => {
              self.location_data[elem["FullName"]] = elem;
            });
          })
        )
        .catch((e) => {
          self.network_error = true;
          console.log(e);
        });
    },
  },
  computed: {
    user_account: function () {
      return this.$auth.user;
    },
    filtered_devices_known: function () {
      try {
        return this.devices.filter((dev) => {
          return dev.LocationType.toLowerCase().includes("friendly");
        });
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    filtered_devices: function () {
      try {
        var filtered_assets = [];
        if (
          this.devices &&
          this.devices.length > 0 &&
          this.location_data &&
          Object.keys(this.location_data).length > 0
        ) {
          filtered_assets = this.devices
            .filter((dev) => {
              switch (this.current_list.toLowerCase().trim()) {
                case "all":
                  return true;
                case "at poi":
                  return dev.LocationType.toLowerCase().trim().includes("friendly");
                case "outside poi":
                  return !dev.LocationType.toLowerCase().trim().includes("friendly");
                case "friendly":
                  return dev.LocationType.toLowerCase().trim() == "friendly";
                case "non-friendly":
                  return (
                    dev.LocationType.toLowerCase().trim().includes("friendly") &&
                    dev.LocationType.toLowerCase().trim() != "friendly"
                  );
                case "fluid":
                  return dev.DeviceStatus.toLowerCase().trim() == "fluid";
                case "static":
                  return dev.DeviceStatus.toLowerCase().trim() == "static";
                default:
                  return true;
              }
            })
            .map((elem) => {
              elem["LocationID"] = this.location_data[elem["CurrentPOI"]][["LocationID"]];
              elem["FlowRate"] = this.location_data[elem["CurrentPOI"]][["FlowRate"]];
              elem["FluidAssets"] = this.location_data[elem["CurrentPOI"]][["FluidAssets"]];
              elem["FullName"] = this.location_data[elem["CurrentPOI"]][["FullName"]];
              elem["LocationCategory"] = this.location_data[elem["CurrentPOI"]][["LocationCategory"]];
              elem["StaticAssets"] = this.location_data[elem["CurrentPOI"]][["StaticAssets"]];
              elem["TotalAssets"] = this.location_data[elem["CurrentPOI"]][["TotalAssets"]];
              elem["Utilisation"] = this.location_data[elem["CurrentPOI"]][["Utilisation"]];
              return elem;
            });
        }
        return filtered_assets;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    updated_filtered_devices: function () {
      return this.filtered_devices.filter((elem) => {
        return this.selected_poi && this.selected_poi.length > 0
          ? elem.CurrentPOI == this.selected_poi[0] || this.selected_poi.indexOf(elem.DeviceID) != -1
          : true;
      });
    },
    map_data: function () {
      try {
        const initialValue = {};
        let distinct_poi_data = this.filtered_devices.reduce((acc, item) => {
          let isKnownLocation = item.CurrentPOI.toLowerCase() == "no location data" ? false : true;
          let isOutsidePOIs = item.CurrentPOI.toLowerCase() == "outside pois";
          if (isKnownLocation) {
            if (isOutsidePOIs) {
              acc[item.CurrentLat + "," + item.CurrentLng] = acc[item.CurrentLat + "," + item.CurrentLng] || [];
              acc[item.CurrentLat + "," + item.CurrentLng].push({
                latitude: item.CurrentLat,
                longitude: item.CurrentLng,
                name: item.DeviceID,
                locationType: "outside",
              });
            } else {
              acc[item.CurrentPOI] = acc[item.CurrentPOI] || [];
              acc[item.CurrentPOI].push({
                latitude: item.CurrentLat,
                longitude: item.CurrentLng,
                name: item.CurrentPOI,
                locationType: item["LocationType"],
                LocationID: item["LocationID"],
                Utilisation: item["Utilisation"],
                TotalAssets: item["TotalAssets"],
                StaticAssets: item["StaticAssets"],
                LocationCategory: item["LocationCategory"],
                FullName: item["FullName"],
                FlowRate: item["FlowRate"],
                FluidAssets: item["FluidAssets"],
              });
            }
          }
          return acc;
        }, initialValue);
        let poi_arr = [];
        Object.keys(distinct_poi_data).forEach((key) => {
          let temp = distinct_poi_data[key][0];
          temp["totalAssets"] = distinct_poi_data[key].length;
          if (distinct_poi_data[key].length > 1) {
            var name = [];
            for (let l = 0; l < distinct_poi_data[key].length; l++) {
              name.push(distinct_poi_data[key][l].name);
            }
            temp["name"] = name;
          }
          poi_arr.push(temp);
        });
        return poi_arr;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    chart_data_devices_known: function () {
      let tempObj = {
        activeDevices: 0,
        inactiveDevices: 0,
        devicesAtFriendlyPOI: 0,
        devicesAtNonfriendlyPOI: 0,
      };
      this.filtered_devices_known.forEach(function (item) {
        if (item.DeviceStatus.toLowerCase().trim() == "fluid") tempObj.activeDevices++;
        else tempObj.inactiveDevices++;
        if (item.LocationType.toLowerCase().trim() == "friendly") tempObj.devicesAtFriendlyPOI++;
        else tempObj.devicesAtNonfriendlyPOI++;
      });
      return [
        [
          "Inside Network",
          "Assets",
          {
            role: "tooltip",
            type: "string",
            p: { html: true, role: "tooltip" },
          },
        ],
        [
          `Friendly`,
          tempObj.devicesAtFriendlyPOI,
          {
            msg: "Total Assets at POIs which you have marked as friendly locations",
            title: "Friendly POI",
            footer: `${tempObj.devicesAtFriendlyPOI}(${
              Math.round((tempObj.devicesAtFriendlyPOI / this.filtered_devices_known.length) * 10000) / 100
            }%)`,
          },
        ],
        [
          `Non-friendly`,
          tempObj.devicesAtNonfriendlyPOI,
          {
            msg: "Total Assets at POIs which you have marked as non-friendly locations",
            title: "Non-Friendly POI",
            footer: `${tempObj.devicesAtNonfriendlyPOI}(${
              Math.round((tempObj.devicesAtNonfriendlyPOI / this.filtered_devices_known.length) * 10000) / 100
            }%)`,
          },
        ],
      ];
    },
    filtered_devices_unknown: function () {
      try {
        return this.devices.filter((dev) => {
          return !dev.LocationType.toLowerCase().includes("friendly");
        });
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    chartData: function () {
      let total = this.filtered_devices_known.length + this.filtered_devices_unknown.length;
      return [
        [
          "Asset Location",
          "Total Assets",
          {
            role: "tooltip",
            type: "string",
            p: { html: true, role: "tooltip" },
          },
        ],
        [
          `At POI`,
          this.filtered_devices_known.length,
          {
            msg: "Devices which are at a saved/known POI",
            title: "Total Assets At POI.",
            footer: `${this.$numberWithCommas(this.filtered_devices_known.length)}(${
              Math.round((this.filtered_devices_known.length / total) * 10000) / 100
            }%)`,
          },
        ],
        [
          `Outside POI `,
          this.filtered_devices_unknown.length,
          {
            msg: "Devices which are not at a saved/known POI",
            title: "Total Assets Outside POI",
            footer: `${this.$numberWithCommas(this.filtered_devices_unknown.length)}(${
              Math.round((this.filtered_devices_unknown.length / total) * 10000) / 100
            }%)`,
          },
        ],
      ];
    },
    chart_data_monetary: function () {
      let total = this.filtered_devices_known.length + this.filtered_devices_unknown.length;
      return [
        [
          "Asset Location",
          "Total Assets",
          {
            role: "tooltip",
            type: "string",
            p: { html: true, role: "tooltip" },
          },
        ],
        [
          `At POI (€)`,
          this.filtered_devices_known.length * this.device_cost,
          {
            msg: "Total value of Assets At POI.",
            title: "",
            footer: `&euro; ${this.$numberWithCommas(this.filtered_devices_known.length * this.device_cost)}(${
              Math.round((this.filtered_devices_known.length / total) * 100 * this.device_cost) / 100
            }%)`,
          },
        ],
        [
          `Outside POI (€)`,
          this.filtered_devices_unknown.length * this.device_cost,
          {
            msg: "Total value of Assets Outside POI",
            title: "",
            footer: `&euro; ${this.$numberWithCommas(this.filtered_devices_unknown.length * this.device_cost)}(${
              Math.round((this.filtered_devices_unknown.length / total) * 100 * this.device_cost) / 100
            }%)`,
          },
        ],
      ];
    },
    chart_data_device_status: function () {
      let total = this.filtered_devices_known.length + this.filtered_devices_unknown.length;
      let fluid_assets = 0;
      let static_assets = 0;
      this.devices.forEach(function (item) {
        if (item.DeviceStatus) {
          if (item.DeviceStatus.toLowerCase().trim() == "fluid") fluid_assets++;
          else static_assets++;
        }
      });
      return [
        [
          "Location Type",
          "Total Assets",
          {
            role: "tooltip",
            type: "string",
            p: { html: true, role: "tooltip" },
          },
        ],
        [
          `Fluid`,
          fluid_assets,
          {
            msg: "Assets which are moving across POIs within a pre-defined time period",
            title: "Total Fluid Assets",
            footer: `${this.$numberWithCommas(fluid_assets)}(${Math.round((fluid_assets / total) * 10000) / 100}%)`,
          },
        ],
        [
          `Static`,
          static_assets,
          {
            msg: "Assets which have been at the same POI for more than a pre-defined time period",
            title: "Total Static Assets",
            footer: `${this.$numberWithCommas(static_assets)}(${Math.round((static_assets / total) * 10000) / 100}%)`,
          },
        ],
      ];
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .export-div {
  top: 35px;
}
</style>
